module.exports = __webpack_public_path__ + "media/components/country-flag/static/ec-d488f17506c50539a62f284af9e2a235.svg";